import { createSlice } from '@reduxjs/toolkit'

export const configStateSlice = createSlice({
  name: 'configState',
  initialState: {
    maxPlayers: 10,
    minPlayers: 4,
    turns : 1,
    rounds: 2,
    time: 10,
    strokes : 1,
    censorWord : false,
  },
  reducers: {
    initConfigState: (state, action) => {
      const newState = action.payload;
      return newState
    },
    setMaxPlayers: (state, action) => {
      state.maxPlayers = parseInt(action.payload)
    },
    setMinPlayers: (state, action) => {
      state.minPlayers = parseInt(action.payload)
    },
    setTurns: (state, action) => {
      state.turns = parseInt(action.payload)
    },
    setRounds: (state, action) => {
      state.rounds = parseInt(action.payload)
    },
    setTime: (state, action) => {
      state.time = parseInt(action.payload)
    },
    setStrokes: (state, action) => {
      state.strokes = parseInt(action.payload)
    },
    setCensorWord: (state, action) => {
      state.censorWord = action.payload
    },
  },
})

export const { initConfigState, setMaxPlayers, setMinPlayers, setTurns, setRounds, setTime, setStrokes, setCensorWord } = configStateSlice.actions

export default configStateSlice.reducer